var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-tooltip',{attrs:{"delay":_vm.tooltipDelay,"text":_vm.tooltipText,"tooltipPosition":_vm.tooltipPosition}},[_c('feather-icon',{attrs:{"icon":"FileTextIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.open}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }